
import { AnyAction } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from '../../store';
import { getSelectedNode } from 'features/FMTree';
import { TreeNodeType, TreeDisplayStateType  } from '../../store/FMTree/FMTreeReducer';

export const showGeofenceOnMap = (
): ThunkAction<{}, RootState, {}, AnyAction> =>
    (dispatch, getState, fortMap: any) => {
        const state = getState();
        const selectedGeofence = getSelectedNode(state, TreeDisplayStateType.mainGeofencesTree);
        if (selectedGeofence && selectedGeofence.type === TreeNodeType.item) {
            // тайм-аут нужен для того, чтобы геозона успела отобразиться на карте
            setTimeout(() => fortMap.geoService.selectGeofence(selectedGeofence.id), 50);
        }
        return null;
    };
